@let portalLead = portalLead$ | async;
@if (ancillaryUpsell) {
  <ng-container *ngTemplateOutlet="portalLeadTemplate; context: { portalLead: portalOrder }" />
} @else if (portalLead) {
  <ng-container *ngTemplateOutlet="portalLeadTemplate; context: { portalLead }" />
}

<ng-template #portalLeadTemplate let-portalLead="portalLead">
  @let tipsAmount = state.tipsAmount?.toString() ?? '';

  <stepper
    [step]="Steps.OverviewAndPayment"
    [isChangeMode]="portalOrder.isChange"
    [tiers]="portalTiers"
    [perpetual]="state.perpetual"
  />

  <div class="d-flex flex-column gratitude">
    <div class="d-flex gratitude-body">
      <div class="w-100">
        <div class="d-flex gratitude-header">
          <div class="d-flex align-items-center">
            <img
              class="gratitude-header-img"
              src="assets/icons/volunteer_activism.svg"
              alt="gratuity"
            />
            <h2 class="semi-bold ml-2 header-title">Gratuity</h2>
          </div>
        </div>

        <div
          class="d-flex align-items-center g-5 justify-content-between gratitude-card offer-card gray"
        >
          <div class="offer-card-text gratitude-card-text">
            <div class="d-flex flex-column g-1">
              <h3 class="bold">Note from {{ portalLead.salesAgent.fullName }}</h3>
              <p>Your travel expert</p>
            </div>

            <div class="d-flex g-4 align-items-center">
              <p class="semi-bold">{{ portalLead.salesAgent.deals }} planned trips</p>
              <div class="gratitude-card-text-separator"></div>
              <p class="semi-bold">
                {{ portalLead.salesAgent.avgSavings | portalCurrency }} saved on average
              </p>
            </div>

            <p>
              Hey {{ portalLead?.firstName }}, it’s been a pleasure working with you and I hope our
              service was up to your expectations. Safe and happy travels!
            </p>
          </div>
          <img
            class="offer-card-img"
            [src]="
              portalLead.salesAgent.picture
                ? portalLead.salesAgent.picture
                : 'assets/images/avatar_placeholder.webp'
            "
            onerror="this.src='assets/images/avatar_placeholder.webp'"
            alt="agent avatar"
          />
        </div>

        <div class="d-flex flex-column mt-4">
          <div class="buttons-container">
            <div class="buttons-container-item-top">
              <radio-toggle-button
                title="$0 — Skip for now"
                dataId="not-now"
                [value]="noTipsValue"
                [isSelected]="tipsAmount === noTipsValue"
                (click)="selectTipsAmount(noTipsValue)"
              />
            </div>

            <div class="buttons-container-item-top">
              <radio-toggle-button
                title="Custom amount"
                dataId="custom amount"
                [value]="customValue"
                [isWritable]="true"
                [isError]="isCustomValueError"
                [isSelected]="customValue === tipsAmount"
                (valueInputFocusOut)="onCustomValueFocusOut($event)"
                (valueChange)="updateCustomValue($event)"
              />
            </div>

            @for (amount of tipsAmounts; track amount) {
              <div class="buttons-container-item top">
                <radio-toggle-button
                  [title]="+amount | portalCurrency"
                  [dataId]="amount.toString()"
                  [value]="amount"
                  [isSelected]="tipsAmount === amount"
                  (click)="selectTipsAmount(amount)"
                />
              </div>
            }
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row">
          <div class="flex-1">
            <div class="d-none d-md-flex mt-6">
              <ds-button
                (click)="back()"
                variant="secondary"
                [fullWidth]="true"
                class="w-md-unset"
                leadingIcon="chevronLeft"
                data-id="back"
                label="Back"
              />

              <ds-button
                (click)="submit()"
                [fullWidth]="true"
                class="ml-md-auto w-md-unset"
                data-id="submit"
                [disabled]="isCustomValueError"
                trailingIcon="chevronRight"
                [label]="nextButtonTitle"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="summary">
        <ng-container *ngTemplateOutlet="summaryBlock" />
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row">
      <div class="d-flex flex-column d-md-none mt-8">
        <ds-button
          (click)="submit()"
          [fullWidth]="true"
          class="w-md-unset"
          data-id="submit"
          [disabled]="isCustomValueError"
          trailingIcon="chevronRight"
          [label]="nextButtonTitle"
        />

        <ds-button
          (click)="back()"
          variant="secondary"
          leadingIcon="chevronLeft"
          [fullWidth]="true"
          class="mt-4 w-md-unset"
          data-id="back"
          label="Back"
        />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #summaryBlock>
  <price-summary
    [option]="portalOrder"
    [tier]="state.tier"
    [disruptionProtection]="state.disruptionProtection"
    [tipsAmount]="state.tipsAmount"
    [cancelForAnyReason]="state.cancelForAnyReason"
    [promocodeDiscountAmount]="state.promocodeDiscountAmount"
    [bundle]="state.bundle"
  />
</ng-template>
